import { useTRPCAPI, useTRPCClientAPI, useTRPCMutation, useTRPCQuery } from '../../../../trpc/trpc';
import type { CampaignResultsPage } from '../outreachTypes';
import { useInvalidateOutreach } from './useInvalidateOutreach';
import { useRetry } from './useRetry';

/**
 * `outreach.campaigns.results` (design outreach-v2 n1, n3) and "Pitch <next song> to them first"
 * (`createFromWarm`). The realtime events of the campaign read it again (area `campaigns`).
 */
export function useCampaignResults(accountId: number, campaignUuid: string) {
  const trpcAPI = useTRPCAPI();
  const trpcClient = useTRPCClientAPI();
  const invalidate = useInvalidateOutreach();
  const query = useTRPCQuery(
    trpcAPI.outreach.campaigns.results.queryOptions({ accountId, campaignUuid }, { retry: false })
  );
  const retry = useRetry(query.refetch);
  const fromWarm = useTRPCMutation({
    mutationFn: (catalogItemUuid: string) =>
      trpcClient.outreach.campaigns.createFromWarm.mutate({
        accountId,
        fromCampaignUuid: campaignUuid,
        catalogItemUuid,
      }) as Promise<{ campaignUuid: string; warm: number }>,
    onSuccess: () => invalidate(['campaigns', 'home']),
  });
  return {
    results: (query.data ?? undefined) as CampaignResultsPage | undefined,
    isLoading: query.isLoading,
    error: query.error,
    retry,
    createFromWarm: fromWarm.mutateAsync,
    isCreatingFromWarm: fromWarm.isPending,
  };
}
